import React from 'react';
import { Clock, Users, MessageSquare, Image, FileArchive, Bell } from 'lucide-react';

const WhySection = () => {
  const benefits = [
    {
      icon: Clock,
      title: "Informasi Akurat",
      description: "Informasi jadwal untuk para tamu disampaikan dengan akurat dan konsisten"
    },
    {
      icon: Users,
      title: "Tanpa Pertanyaan Berulang",
      description: "Keluarga tidak perlu menjawab berulang dari tamu yang berbeda"
    },
    {
      icon: MessageSquare,
      title: "Doa & Pesan Interaktif",
      description: "Tamu bisa kirim doa dan pesan melalui chat yang interaktif"
    },
    {
      icon: Image,
      title: "Foto & Video Real-time",
      description: "Tamu bisa kirim foto dan video secara real time ke keluarga"
    },
    {
      icon: FileArchive,
      title: "Arsip Kenangan Digital",
      description: "Semua arsip disatukan sebagai kenangan untuk keluarga dalam file digital"
    },
    {
      icon: Bell,
      title: "Update Perubahan",
      description: "Jika ada perubahan jadwal, seluruh tamu mendapat pesan perubahan"
    }
  ];

  return (
    <section className="py-20 bg-funeral-secondary">
      <div className="max-w-7xl mx-auto px-4">
        <h2 className="text-4xl md:text-5xl font-serif text-center text-funeral-gold mb-4">
          Kenapa Kenangan.AI
        </h2>
        <div className="divider"></div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
          <div className="md:col-span-2 lg:col-span-3 bg-funeral-dark/30 p-8 rounded-lg border border-funeral-border/50">
            <div className="text-center text-funeral-light text-lg leading-relaxed mb-6">
              <p>Di masa duka, keluarga sedang lelah secara fisik dan emosional. Pertanyaan para tamu sering berulang dan banyak sekali. Informasi yang perlu disampaikan sering ada di beberapa orang. Pesan belasungkawa sering tidak tersampaikan dengan tertata.</p>
            </div>
            <p className="text-center text-2xl text-funeral-gold font-serif">
              Kenangan.AI membantu semua itu.
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => {
            const IconComponent = benefit.icon;
            return (
              <div 
                key={index}
                className="bg-funeral-dark p-6 rounded-sm border border-funeral-border hover:border-funeral-gold transition-all hover:shadow-lg hover:shadow-funeral-gold/10 group"
              >
                <div className="text-funeral-gold mb-4 flex items-center justify-center w-16 h-16 bg-funeral-gold/10 rounded-full group-hover:bg-funeral-gold/20 transition-all">
                  <IconComponent size={32} />
                </div>
                <h3 className="text-xl font-serif text-funeral-light mb-2">
                  {benefit.title}
                </h3>
                <p className="text-funeral-light text-sm">
                  {benefit.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhySection;
